import { Apollo } from 'src/gql/generated';

/**
 * Signing-lifecycle states shown in the list metadata row and the Signing Status filter.
 * These live apart from `SigningStatusBadge` because the badge reaches the filter modules
 * through the `src/workflow` barrel: defined next to the component, the constant is still
 * undefined by the time that import cycle comes back around and a filter reads it at
 * module scope.
 */
export const SIGNING_STATUS_STATES = [
  Apollo.WorkflowState.ReadyForSignature,
  Apollo.WorkflowState.Signing,
  Apollo.WorkflowState.Signed,
] as const;

export type SigningStatusState = (typeof SIGNING_STATUS_STATES)[number];

export function getIsSigningStatusState(
  state: string | Apollo.WorkflowState
): state is SigningStatusState {
  return SIGNING_STATUS_STATES.some(signingState => signingState === state);
}
